import { computed, watch } from "vue";
import { useRoute } from "vue-router";

export function useDocumentTitle() {
  const route = useRoute()
  const title = computed(() => route.meta.title || '')

  watch(
    () => route.meta.title,
    (title) => {
      document.title = title != null && title != 'Könyvelő' ? `${title} - VI-Share` : 'VI-Share'
    },
    { immediate: true }
  )

  return { title };

}

